import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import store from "./store";
import i18n from "./translations";
import pluginTigreLayout from 'plugin-tigre-layout';
import router from "./router";
import { VueMaskDirective } from "v-mask";
import { TiptapVuetifyPlugin } from "tiptap-vuetify";
import "tiptap-vuetify/dist/main.css";
import "vuetify/dist/vuetify.min.css";
import "./assets/css/style.css";
import "./helpers/filter";
import "./helpers/file_handler";
import "./plugins/currency-field";
import "./plugins/gtag";
import "./plugins/msal";
import "./plugins/lodash";
import './plugins/global-components';
import moment from './plugins/moment';


Vue.use(TiptapVuetifyPlugin, {
  vuetify,
  iconsGroup: "mdi"
});
Vue.directive('mask', VueMaskDirective);
Vue.use(pluginTigreLayout, vuetify);

Vue.config.productionTip = false;
Vue.prototype.$moment = moment;

new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount("#app");
